module.exports = __webpack_public_path__ + "img/gentlemen-club-carousel-17.c0fa5972.png";